import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exit",
  "use": "exit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"exit\"><g fill-rule=\"evenodd\"><path d=\"M7 4h10v11H7z\" opacity=\".09\" /><path d=\"M7 10v4c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v4H4.143L5 6 2 9.5 5 13l-.857-3H7v2h1v-2H7Zm1 0v4.154c0 .474.45.846 1 .846h7c.54 0 1-.38 1-.846V4.846C17 4.372 16.55 4 16 4H9c-.54 0-1 .38-1 .846V9h5v1H8Zm0-1V7H7v2h1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol